import { render } from "./Trigger.vue?vue&type=template&id=5ad2227c&ts=true&lang=pug"
import script from "./Trigger.vue?vue&type=script&lang=ts&setup=true"
export * from "./Trigger.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__